export const BASE_URL = process.env.REACT_APP_DOMAIN;
export const BASE_API_URL = `${BASE_URL}/api/admin`;
// status codes
export const UNAUTHORISED = 401;
export const NON_EXISTING_USER = 428;
export const STATUS_CREATED = 201;
export const STATUS_OK = 200;
export const STATUS_NO_CONTENT = 204;
